import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const loadState = (): { serviceProviderId: string; fullName?: string; } => {
    const savedState = localStorage.getItem('selectedServiceProviderForUser');
    return savedState ? JSON.parse(savedState) as { serviceProviderId: string; fullName?: string; } : { serviceProviderId: '' };
};

const initialState: { serviceProviderId: string; fullName?: string; } = loadState();

const selectedServiceProviderForUserSlice = createSlice({
    name: 'selectedServiceProviderForUser',
    initialState,
    reducers: {
        setSelectedServiceProviderForUser: (state, action: PayloadAction<{ serviceProviderId: string; fullName?: string; }>) => {
            localStorage.setItem('selectedServiceProviderForUser', JSON.stringify(action.payload));
            return action.payload;
        },
        removeSelectedServiceProviderForUser: (state) => {
            localStorage.removeItem('selectedServiceProviderForUser');
            return { serviceProviderId: '' };
        },
    },
});

export const { setSelectedServiceProviderForUser, removeSelectedServiceProviderForUser } = selectedServiceProviderForUserSlice.actions;
export default selectedServiceProviderForUserSlice.reducer;
export const selectSelectedServiceProviderForUser = (state: RootState) => state.selectedServiceProviderForUser;